import { Button } from '@/components/ui/button';
import { ScrollArea } from '@/components/ui/scroll-area';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { cn } from '@/lib/utils';
import { useAuth } from '@/contexts/AuthContext';
import { useState, useEffect } from 'react';
import { getRoleLabel } from '@/lib/roles';
import { AppNavLinks } from './AppNavLinks';

const SIDEBAR_STATE_KEY = 'sidebar-collapsed';

export const Sidebar = () => {
  const { user } = useAuth();
  const [isCollapsed, setIsCollapsed] = useState(() => {
    const savedState = localStorage.getItem(SIDEBAR_STATE_KEY);
    return savedState ? JSON.parse(savedState) : false;
  });

  useEffect(() => {
    localStorage.setItem(SIDEBAR_STATE_KEY, JSON.stringify(isCollapsed));
  }, [isCollapsed]);

  return (
    <div
      className={cn(
        'hidden md:flex h-full border-r bg-white flex-col transition-all duration-300 shrink-0',
        isCollapsed ? 'w-16' : 'w-64'
      )}
    >
      <div className="p-4 flex items-center justify-between">
        <div className={cn('flex items-center', isCollapsed && 'justify-center')}>
          <div className="p-1 rounded mr-2">
            <img src="assets/logo1.png" alt="Gramosi Logo" className="h-10 w-10" />
          </div>
          {!isCollapsed && <h1 className="text-xl font-bold">Gramosi</h1>}
        </div>
        <Button
          variant="ghost"
          size="icon"
          onClick={() => setIsCollapsed(!isCollapsed)}
          className="h-8 w-8 z-50"
          aria-label={isCollapsed ? 'Expand sidebar' : 'Collapse sidebar'}
        >
          {isCollapsed ? (
            <ChevronRight className="h-5 w-5" />
          ) : (
            <ChevronLeft className="h-4 w-4" />
          )}
        </Button>
      </div>

      {user && !isCollapsed && (
        <div className="flex items-center px-4 pb-2">
          <div className="w-8 h-8 rounded-full bg-gray-200 flex items-center justify-center overflow-hidden mr-2">
            {user.avatar ? (
              <img
                src={user.avatar}
                alt={user?.username}
                className="w-full h-full object-cover"
              />
            ) : (
              <span className="text-xs font-medium">
                {user?.username?.charAt(0)}
              </span>
            )}
          </div>
          <div className="min-w-0">
            <p className="text-sm font-medium truncate">{user?.username}</p>
            <p className="text-xs text-gray-500">{getRoleLabel(user.role)}</p>
          </div>
        </div>
      )}

      <ScrollArea className="flex-1">
        <AppNavLinks collapsed={isCollapsed} />
      </ScrollArea>
    </div>
  );
};
